const noticeType_commentsThumbUp = 201; //评论被点赞
const noticeType_travelNoteCommented = 202; //游记被评论
const noticeType_userRegister = 101; //新用户注册
const noticeType_travelNoteApproved = 102; //游记被采纳
const noticeType_userFeedback = 204; //用户反馈


export default {
  noticeType_commentsThumbUp,
  noticeType_travelNoteCommented,
  noticeType_userRegister,
  noticeType_travelNoteApproved,
  noticeType_userFeedback
};
